__webpack_require__.p = "https://brand-cms.clik.vn/";